import React from 'react';
import { connect } from 'react-redux';
// import stripe from 'tipsi-stripe';
// import validator from 'card-validator';
import axios from 'axios';
import clockIcon from '../../assets/images/clock-icon.svg';
import accountIcon from '../../assets/images/account.svg';
import houseIcon from '../../assets/images/house-current.svg';
import creditcardicon from '../../assets/images/credit-card-icon.svg';
import LoadingSpinner from '../common/LoadingSpinner';
import { ModalBackButton } from '../common/ModalBackButton';
import { API_URL } from '../../config/constants';
import FoodItemAddonSelection from '../fooditems/FoodItemAddonSelection';
import MenuItemBottomButton from '../common/menuitem/MenuItemBottomButton';
import { applyPromo, cartInfoUpdate, selectLoyaltyReward, cartReset } from '../../actions/cart';
import { setCartPanel } from '../../actions/panels';
import { renderCartItems, hasCartItems } from '../../utils/cartItemUtil';
import { getFormattedTime } from '../../utils/dateUtil';
import { authSuccess, setCurrentOrder } from '../../actions/auth';

class OrderCheckout extends React.Component {

    constructor(props) {
        super(props);

        this.applyPromo = this.applyPromo.bind(this);
        this.validateCard = this.validateCard.bind(this);
        this.submitOrder = this.submitOrder.bind(this);
        this.getActiveLoyaltyButton = this.getActiveLoyaltyButton.bind(this);

        this.state = {
            hasPaymentOptions: false,
            loading: false,
            isCompleting: false,
            message: '',
            tipAmount: 0.00,
            cc_number: '',
            cc_expiry: '',
            cc_cvc: '',
            cc_postalCode: '',
            viewCCInfo: false,
            orderInProcess: false,
            onlinePaySelected: true,
            instorePaySelected : false,
            activeLoyaltyButton: 0,
        };
    }

    componentDidMount() {
        
        if (this.props.logged_in && this.props.loggedUser.hasDefaultPayment && !this.props.viewCCInfo) {

            if(this.props.cart.saved_card == 0){

                this.setState((prevState) => ({hasPaymentOptions: true}));
                this.props.dispatch(cartInfoUpdate({ prop: 'saved_card', value: this.props.loggedUser.defaultPaymentId }));
                this.props.dispatch(cartInfoUpdate({ prop: 'saved_card_name', value: this.props.loggedUser.defaultPayment }));

            }else{

                this.props.dispatch(cartInfoUpdate({ prop: 'saved_card', value: this.props.cart.saved_card }));
                this.props.dispatch(cartInfoUpdate({ prop: 'saved_card_name', value: this.props.cart.saved_card_name }));

            }

        }else{

            this.props.dispatch(cartInfoUpdate({ prop: 'saved_card', value: 0}));
            this.props.dispatch(cartInfoUpdate({ prop: 'saved_card_name', value: ''}));

        }

    }

    componentDidUpdate() {
        
        const viewCCInfo = this.props.viewCCInfo;
        if (!viewCCInfo && this.state.viewCCInfo != false) {
            this.setState(() => ({viewCCInfo: false}));
        }
        else if (viewCCInfo && !this.state.viewCCInfo) {
            this.setState(() => ({viewCCInfo: true}));
        }

        if (!hasCartItems(this.props.cart.items) && !this.state.isCompleting) {
            this.props.dispatch(setCartPanel('cart'));
        }
    }


    chooseOnlinePay() {
        this.setState(() => ({
            onlinePaySelected: true,
            instorePaySelected : false,
        }));
    }

    chooseInStorePay() {
        this.setState(() => ({
            onlinePaySelected: false,
            instorePaySelected : true,
        }));
    }

    updateExpiry(cc_expiry) {

        if (cc_expiry.match(/^\d+(\/\d*)?$/)) {
            if (cc_expiry.length == 2) {
                cc_expiry += "/";
            }
        }

        this.setState(() => ({ cc_expiry }));
    }

    applyPromo() {
     
        this.props.dispatch(cartInfoUpdate({ prop: 'promoError', value: '' }));
        if (this.props.cart.promo_code.trim() != "") {
            this.setState(() => ({message: "Applying your promo, please wait..."}));
            this.props.dispatch(cartInfoUpdate({ prop: 'loading', value: true }));
            this.props.dispatch(applyPromo(this.props.loggedUser.uid, this.props.currentLocation, this.props.cart));
        }
        else {
            this.props.dispatch(cartInfoUpdate({ prop: 'promoError', value: 'Please enter a promo code before applying.' }));
        }
    }

    selectLoyaltyReward(e, reward_id) {
        e.preventDefault();
        this.setState(() => ({message: "Applying your loyalty reward, please wait..."}));
        this.props.dispatch(cartInfoUpdate({ prop: 'loading', value: true }));
        this.props.dispatch(selectLoyaltyReward(this.props.loggedUser.uid, this.props.currentLocation, this.props.cart, reward_id));
        this.setState(() => ({activeLoyaltyButton: reward_id}));
    }

    printTotalMinusPromo() {
        let theTotal = this.props.cart.subtotal - this.props.cart.promo_amount;

        if (theTotal < 0) {
            theTotal = 0.00;
        }

        return theTotal.toFixed(2);
    }

    printTotalMinusLoyalty() {
        let theTotal = this.props.cart.subtotal - this.props.cart.promo_amount - this.props.cart.loyalty_redeem_amount;

        if (theTotal < 0) {
            theTotal = 0.00;
        }

        return theTotal.toFixed(2);
    }

    addTipPercentage(percentage) {
        let thePercentageAmount = this.props.cart.subtotal * (percentage / 100);
        this.props.dispatch(cartInfoUpdate({ prop: 'tip', value: parseFloat(thePercentageAmount.toFixed(2)) }));
        this.setState(() => ({tipAmount: thePercentageAmount.toFixed(2)}));
    }

    addTipAmount() {

        this.setState(() => ({message: "Adding your tip, please wait..."}));
        this.props.dispatch(cartInfoUpdate({ prop: 'loading', value: true }));
        let theTip = 0
        if (this.state.tipAmount.match(/^\s*\d+(\.\d+)?\s*$/) || this.state.tipAmount.match(/^\s*\.\d+\s*$/)) {
            theTip = parseFloat(this.state.tipAmount).toFixed(2);
        }

        this.props.dispatch(cartInfoUpdate({ prop: 'tip', value: parseFloat(theTip) }));
        this.props.dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
    }

    async validateCard() {

        if (!this.state.orderInProcess) {
            const setState = this.setState.bind(this);
            const { dispatch, token } = this.props;
            this.setState(() => ({message: "Submitting your Order..."}));
            dispatch(cartInfoUpdate({ prop: 'loading', value: true }));
                
            this.setState(() => ({orderInProcess: true}));

            if (this.props.cart.payment_method == "online_payment" && this.props.cart.total > 0) {

                const expiry_info = this.state.cc_expiry.match(/^\s*(\d\d)\/(\d\d\d\d)\s*$/);

                if (this.props.cart.saved_card !== undefined && this.props.cart.saved_card != "" && !this.state.viewCCInfo) {
					
                    this.submitOrder();
				
                } else { 
                    
                    // set the appropriate publishable key
                    if (this.props.cart.savePayment == true) {
                        Stripe.setPublishableKey(this.props.currentLocation.publishable_key);
                    }
                    else {
                        Stripe.setPublishableKey(this.props.currentLocation.location_publishable_key);
                    }

                    const postalCodePattern = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

                    // perform validation on the credit card
                    if (!Stripe.card.validateCardNumber(this.state.cc_number)) {
                        dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                        setTimeout(() => {
                            alert("Invalid credit card number entered.");
                        }, 100);
                        setState(() => ({orderInProcess: false}));
                    }
                    else if (expiry_info == null || !Stripe.card.validateExpiry(expiry_info[1], expiry_info[2])) {
                        dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                        setTimeout(() => {
                            alert("Invalid expiry date entered. Please ensure that you have used all 4 digits of the year (eg. 12/2015)");
                        }, 100);
                        setState(() => ({orderInProcess: false}));
                    }
                    else if (!Stripe.card.validateCVC(this.state.cc_cvc)) {
                        dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                        setTimeout(() => {
                            alert("Invalid CVC entered  .");
                        }, 100);
                        setState(() => ({orderInProcess: false}));
                    }else if(!postalCodePattern.test(this.state.cc_postalCode)){
                        dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                        setTimeout(() => {
                            alert("Invalid Postal Code entered  .");
                        }, 100);
                        setState(() => ({orderInProcess: false}));
                    }
                    else {

                        let validToken = true;
                        if (this.props.cart.stripeToken != "") {    //a token is present, verify that it is still valid
                            Stripe.getToken(this.props.cart.stripeToken, function(status, response) {
                                if (status == 200 && !response.used && response.card.last4 == this.state.cc_number.substr(this.state.cc_number.length - 4)) {   //valid token
                                    this.submitOrder();
                                }
                                else {
                                    validToken = false;
                                }
                            });
                        }
                        else {
                            validToken = false;
                        }
                        
                        if (validToken == false) {
                            const submitOrderFunction = this.submitOrder;
                            Stripe.card.createToken({
                                number: this.state.cc_number,
                                cvc: this.state.cc_cvc,
                                exp_month: expiry_info[1],
                                exp_year: expiry_info[2],
                                address_zip: this.state.cc_postalCode
                            }, function(status, response) {
                                if (response.error) {

                                    // Show the errors on the form
                                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                                    alert(response.error.message);
                                    setState(() => ({orderInProcess: false}));
                                } else {
                                    // response contains id and card, which contains additional card details
                                    var token = response.id;
                                    dispatch(cartInfoUpdate({ prop: 'stripeToken', value: token }));
                                    submitOrderFunction();
                                }
                            });
                        }
                        else {
							this.submitOrder();
						}
                    }
                }
            } else {
				dispatch(cartInfoUpdate({ prop: 'stripeToken', value: '' }));
				this.submitOrder();
			}
        }
    }

    submitOrder() {
        const { dispatch, token } = this.props;
        const setState = this.setState.bind(this);
        let params = {cart: this.props.cart};

        // @NOTE: needed so submission will work and the old apps won't go down, can likely
        //        be removed sometime in the future
        if (params.cart.order_type == "delivery") {
            params.cart.full_address = params.cart.delivery_address;
        }
        else {
            params.cart.full_address = '';
            params.cart.delivery_instructions = '';
        }

        params.lid = this.props.currentLocation.location.id;
        params.submitSource = "onlineOrder";

        if (token) {
            params.token = token;
        }

        axios.post(API_URL+'/api/order/submit', params)
            .then(function(res) {
                if (res.data.status == "success") {

                    // empty the cart
                    setState((prevState) => ({
                        isCompleting: true
                    }));
                    dispatch(cartReset());

                    // update the user info (if it's there)
                    if (res.data.data.userInfo) {
                        dispatch(authSuccess(token, res.data.data.userInfo));
                    }

                    // remove the localStorage cart data
                    window.localStorage.removeItem('c2o.cart.'+params.lid);

                    // we're good, go to an order complete screen
                    dispatch(cartInfoUpdate({ prop: 'completed_order_id', value: res.data.data.oid }));
                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                    
                    window.localStorage.setItem('currentOrderKey', res.data.data.order_key);
                    window.localStorage.setItem('showStatusPage', true);

                    dispatch(setCurrentOrder({order_id: res.data.data.oid, id: 0}));
                    dispatch(setCartPanel('current_status'));

                } else {
                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                    setState(() => ({orderInProcess: false}));
                    
                    setTimeout(() => {
                        alert(res.data.errorMessage);
                    }, 100);
                }
            })
            .catch(function(err) {

                // print an error message!
                //console.log(err);
                //console.log(err.response);
                dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                setState(() => ({orderInProcess: false}));

                if (err.response.status == 400) {
                    setTimeout(() => {
                        alert(err.response.data.message);
                    }, 100);
                } else {
                    setTimeout(() => {
                        alert("There was an error, and our team has been notified.");
                    }, 100);
                }
            });
    }

    renderTotals() {
        return (

            <div>

                <div className="checkout-price-wrapper">
                    <div className="total-summary">
                        <div className="order-total-label">Subtotal:</div>
                        <div className="order-total-label-price">
                            {this.props.cart.subtotal.toFixed(2)}
                        </div>
                    </div>
                    {(this.props.cart.promo_amount > 0) && (
                    <div className="total-summary">
                        <div className="order-total-label">Promo Code Discount:</div>
                        <div className="order-total-label-price">
                            -{this.props.cart.promo_amount.toFixed(2)}
                        </div>
                    </div>
                    )}
                    {(this.props.cart.promo_amount > 0) && (
                        <div className="total-summary">
                        <div className="order-total-label">Subtotal - Promo:</div>
                        <div className="order-total-label-price">
                            {this.printTotalMinusPromo()}
                        </div>
                    </div>
                    )}
                      {(this.props.cart.loyalty_redeem_amount > 0) && (
                           <div className="total-summary">
                           <div className="order-total-label">Loyalty Rewards Discount:</div>
                           <div className="order-total-label-price">
                           -{this.props.cart.loyalty_redeem_amount.toFixed(2)}
                           </div>
                       </div>
                      )}
                      {(this.props.cart.loyalty_redeem_amount > 0) && (
                          <div className="total-summary">
                          <div className="order-total-label">Subtotal - Loyalty Reward:</div>
                          <div className="order-total-label-price">
                              {this.printTotalMinusLoyalty()}
                          </div>
                      </div>
                      )}

                    {(this.props.cart.additional_charge > 0) && (
                        <div className="total-summary">
                            <div className="order-total-label">Additional Charge:</div>
                            <div className="order-total-label-price">
                                {this.props.cart.additional_charge.toFixed(2)}
                            </div>
                        </div>
                    )}

                    {(this.props.cart.delivery_charge > 0) && (
                        <div className="total-summary">
                            <div className="order-total-label">Delivery Fee:</div>
                            <div className="order-total-label-price">
                                {this.props.cart.delivery_charge.toFixed(2)}
                            </div>
                        </div>
                    )}

                    {(this.props.cart.fuel_surcharge > 0) && (
                        <div className="total-summary">
                            <div className="order-total-label">Service Fee:</div>
                            <div className="order-total-label-price">
                                {this.props.cart.fuel_surcharge.toFixed(2)}
                            </div>
                        </div>
                    )}

                    {(this.props.cart.promo_delivery_amount > 0) && (
                    <div className="total-summary">
                        <div className="order-total-label">Delivery Promo Discount:</div>
                        <div className="order-total-label-price">
                            -{this.props.cart.promo_delivery_amount.toFixed(2)}
                        </div>
                    </div>
                    )}

                    {(this.props.cart.tip > 0) && (
                         <div className="total-summary">
                         <div className="order-total-label">Driver Tip:</div>
                         <div className="order-total-label-price">
                            {this.props.cart.tip.toFixed(2)}
                         </div>
                     </div>
                    )}

                    {(this.props.cart.taxes > 0) && (
                        <div className="total-summary">
                        <div className="order-total-label">Taxes:</div>
                        <div className="order-total-label-price">
                            {this.props.cart.taxes.toFixed(2)}
                        </div>
                    </div>
                    )}

                    <div className="total-summary">
                        <div className="order-total-label">Total:</div>
                        <div className="bolded-price less">
                        {(this.props.cart.total+this.props.cart.tip).toFixed(2)}
                        </div>
                    </div>
            
                </div>

            
            </div>
        );
    }

    renderPromo() {
        return (
            <div>
                {(this.props.cart.promoError != "") && <p className="error-text">{this.props.cart.promoError}</p>}
                
                <div className="promo-code-wrapper">

                    <div className="form-block-2 w-form">
                        {/* Input field */}
                        <input
                            className="text-field-input apply-promo-field"
                            label=""
                            placeholder="Enter Promo Code"
                            value={this.props.cart.promo_code}
                            onChange={(e) => this.props.dispatch(cartInfoUpdate({ prop: 'promo_code', value: e.target.value }))}
                        />
                        {/* Apply button */}
                        <div
                            className="submit-button"
                            onClick={this.applyPromo}
                        >
                           <div className="promo-button-text">Apply</div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    getActiveLoyaltyButton(rewardID){
        if(this.state.activeLoyaltyButton == rewardID){
            return ' selectedReward'
        }else{
            return '';
        }
    }

    renderLoyaltyRewards() {
        return (
            <div className="checkoutGreyWindow">
                <p className="checkoutGreyWindowText">You have loyalty rewards available!<br />Want to redeem them?</p>
                <div className="checkoutGreyWindowOptions loyaltyScroll">
                    <button
                        className={"checkoutLoyaltyButtonStyle" + this.getActiveLoyaltyButton(0)}
                        onClick={(e) => {
                            this.selectLoyaltyReward(e, 0);
                        }}
                    >
                        Not Now
                    </button>
                    {this.props.cart.loyalty_rewards.map((theReward) => {
                        return (
                             <button
                                 className={"checkoutLoyaltyButtonStyle" + this.getActiveLoyaltyButton(theReward.id)}
                                 onClick={(e) => {
                                     return this.selectLoyaltyReward(e, theReward.id);
                                 }}
                             >
                                 {theReward.value} Off
                             </button>
                        );
                    })}
                </div>
            </div>
        );
    }

    renderTipWindow() {
        return (
            <div>
                <div className="tip-driver-title">Add a tip for your driver?</div>

                <div className="tip-button-row">
                    <div className="button-wrapper">
                        <a 
                            key={"addtip-5"}  
                            onClick={() => {
                                this.addTipPercentage(5);
                            }}  
                            className="tip-button"
                        >
                            5%
                        </a>
                    </div>

                    <div className="button-wrapper">
                        <a 
                            key={"addtip-10"}  
                            onClick={() => {
                                this.addTipPercentage(10);
                            }} 
                            className="tip-button"
                        >
                            10%
                        </a>
                    </div>

                    <div className="button-wrapper">
                        <a  
                            key={"addtip-15"}  
                            onClick={() => {
                                this.addTipPercentage(15);
                            }} 
                            className="tip-button"
                        >
                            15%
                        </a>
                    </div>
                    
                    <div className="button-wrapper">
                        <a 
                            key={"addtip-20"}  
                            onClick={() => {
                                this.addTipPercentage(20);
                            }} 
                            className="tip-button"
                        >
                            20%
                        </a>
                    </div>
                </div>
                <div>

                    <div className="promo-code-wrapper">
                        <div className="tip-form-block w-form">
                            <input
                                className="text-field-input apply-promo-field"
                                placeholder={"Driver Tip"}
                                value={this.state.tipAmount}
                                onChange={(e) => {
                                    const tipAmount = e.target.value;
                                    this.setState(() => ({tipAmount}));
                                }}
                            />
                             <div
                                className="apply-tip-button tip-submit-button"
                                onClick={() => {
                                    this.addTipAmount();
                                }}
                            >
                                <div className="promo-button-text">Add Tip</div>
                            </div>
                        </div>
                    </div>
                  
                </div> 
            </div>
        );
    }

    renderOrderInformation() {
        return (
            <div>
                <div className="profile-info-wrapper alt-style">
                    <div className="information-wrapper">
                        <div className="name-title checkout-order-title-label-justify">
                            <img src={accountIcon} className="most-small-icons _2" />
                            <div className="text-block-8">Contact Info</div>
                        </div>
                    </div>
                    <div className="name-info smaller">
                        <div>{this.props.cart.name}</div>
                    </div>
                    <div className="name-info smaller">
                        <div>{this.props.cart.phone}</div>
                    </div>
                    <div className="name-info smaller">
                        <div>{this.props.cart.email}</div>
                    </div>
                </div>

                {(this.props.cart.order_type == "delivery") && (
                     <div className="profile-info-wrapper alt-style">
                     <div className="information-wrapper">
                         <div className="name-title checkout-order-title-label-justify">
                             <img src={houseIcon} className="most-small-icons _2" />
                             <div className="text-block-8">Delivery Address</div>
                         </div>
                     </div>
                     <div className="name-info smaller">
                         <div>{this.props.cart.delivery_address}</div>
                     </div>
                     {(this.props.cart.delivery_instructions != "") && (
                          <div className="name-info smaller">
                          <div> {this.props.cart.delivery_instructions}</div>
                      </div>
                     )}
                 </div>
                )}

                <div className="profile-info-wrapper alt-style">
                    <div className="information-wrapper">
                       
                        <div className="name-title checkout-order-title-label-justify">
                            <img src={clockIcon} className="most-small-icons _2" />
                            <div className="text-block-8">Pickup/Delivery Time</div>
                        </div>
                    </div>
                    <div className="name-info smaller">
                        <div>{(this.props.cart.pickup_time != "") ? getFormattedTime(this.props.cart.pickup_time) : "ASAP"}</div>
                    </div>
                </div>  
            </div>
        );
    }

    renderOnlinePayment() {
        if (this.props.logged_in && this.props.loggedUser.hasDefaultPayment && !this.state.viewCCInfo) {
            return (

                <div>
                     <div className="profile-info-wrapper alt-style">
                        <div className="information-wrapper">
                        
                            <div className="name-title checkout-order-title-label-justify">
                            <img src={creditcardicon}  className="most-small-icons _2" />
                                <div className="text-block-8">Payment Info</div>
                            </div>
                            <div className="name-info smaller">
                                <div>{this.props.cart.saved_card_name}</div>
                                <a
                                className="payment-change"
                                    onClick={() => {
                                        this.props.dispatch(setCartPanel('select_payment'));
                                    }}
                                >
                                    Change Payment
                                </a>  
                            </div>
                        </div>        
                    </div>  
                </div>
            );
        }
        else {
            return (
                <div>
                    <div>  
                        {(this.props.logged_in  && this.props.loggedUser.defaultPaymentId != "") && (
                            <div className="update-payment-button">
                                <a
                                    onClick={() => {
                                        this.props.dispatch(setCartPanel('select_payment'));
                                        //this.props.navigation.navigate("ViewCartPaymentOptions");
                                    }}
                                >
                                    Use a Saved Card
                                </a>
                            </div>
                        )}

                    <div className="profile-info-wrapper alt-style">
                        <div className="information-wrapper">
                        
                            <div className="name-title checkout-order-title-label-justify">
                            <img src={creditcardicon}  className="most-small-icons _2" />
                                <div className="text-block-8">Payment Info</div>
                            </div>
                        </div>
                       
                    </div>  
                        <input 
                            label=""
                            placeholder="Enter Credit Card Number..."
                            value={this.state.cc_number}
                            className="credit-card-number-input-field"
                            onChange={(e) => {
                                const cc_number = e.target.value;
                                this.setState(() => ({ cc_number }))}
                            }
                        />

                        <div className="credit-card-form-block ">
                            <input 
                                label=""
                                placeholder="MM/YYYY"
                                value={this.state.cc_expiry}
                                className="text-field-input tip-row-input-field exp-field "
                                onChange={(e) => {
                                    const cc_expiry = e.target.value;
                                    this.setState(() => ({ cc_expiry }))}
                                }
                            />
                            <input 
                                label=""
                                placeholder="CVC"
                                value={this.state.cc_cvc}
                                className="text-field-input tip-row-input-field cvc-field"
                                onChange={(e) => {
                                    const cc_cvc = e.target.value;
                                    this.setState(() => ({ cc_cvc }))}
                                }
                            />
                        </div>
                        <input 
                            label=""
                            placeholder="Postal Code"
                            value={this.state.cc_postalCode}
                            className="credit-card-number-input-field"
                            onChange={(e) => {
                                const cc_postalCode = e.target.value;
                                this.setState(() => ({ cc_postalCode }))}
                            }
                        />

                    </div>

                    {(this.props.logged_in) && (
                        <div
                            className="food-item-addon-selection-window"
                        >
                            <input
                                type="checkbox"
                                onClick={() => {   
                                    if (this.props.cart.savePayment) {
                                        // it is there, remove
                                        this.props.dispatch(cartInfoUpdate({prop: 'savePayment', value: false}));
                                    }
                                    else {
                                        // it isn't there, add it
                                        this.props.dispatch(cartInfoUpdate({prop: 'savePayment', value: true}));
                                    }
                                }}
                                checked={this.props.cart.savePayment}
                                id={"save-payment"}
                        
                            />
                            <label className="selectionLabelText" for={"save-payment"}>Save Payment</label>
                        </div>
                    )}
                </div>
            );
        }
    }

    renderCheckoutPaymentInfo() {
        return (
            <div className="cart-input-field" >
                {(this.props.currentLocation.location.payment_type == 'BOTH') && (
                    <div>
                        <div className="tip-driver-title">How are you paying?</div>
                        <div className="checkout-pickup-options"
                                style={{
                                    justifyContent: (this.props.cart.order_type == 'delivery') ? 'flex-end' : 'space-between'
                                }}
                            >
                            <div className="option-button">
                                <a 
                                    className={(this.props.cart.payment_method == "online_payment") ? 'selected-checkout' : ''}
                                    onClick={() => {
                                        this.props.dispatch(cartInfoUpdate({prop: 'payment_method', value: 'online_payment'}));
                                    }}
                                >
                                    Online
                                </a>
                            </div>
                            {(this.props.cart.order_type != "delivery") && (
                                <div className="option-button">
                                    <a
                                        className={(this.props.cart.payment_method == "online_payment") ? '' : 'selected-checkout'}
                                        onClick={() => {
                                            this.props.dispatch(cartInfoUpdate({prop: 'payment_method', value: 'in_store'}));
                                        }}
                                    >
                                    In Store
                                    </a>
                                </div>
                            )}
                        </div>
                        
                    

      
                    </div>
                )}
                    {(this.props.cart.payment_method == "in_store") && (
                    <div className="profile-info-wrapper alt-style">
                        <div className="information-wrapper">
                            <div className="name-title checkout-order-title-label-justify">
                                <img src={creditcardicon} className="most-small-icons _2" />
                                <div className="text-block-8">Payment Info</div>
                            </div>
                        </div>
                        <div className="name-info smaller">
                            <div>{(this.props.cart.order_type == "Pay at the Door.") ? "" : "Pay in Store."}</div>
                        </div>
                    </div>     
                    )}
                {(this.props.cart.payment_method == "online_payment") && this.renderOnlinePayment()}
            </div>
        );
    }

    render() {

        if (this.props.cart.loading) {
            return (
                <LoadingSpinner />
            )
        } else {
            return (
                <div className="checkout-page-wrapper">
                    <div className="close-button">         
                        <ModalBackButton 
                            clickAction={() => this.props.dispatch(setCartPanel("order_information"))}
                        />             
                    </div>
                    <h2 className="heading in-item add-new-addy">Checkout</h2>
                    <div className="order-summary-wrapper">
                        {/* call renderCartItems within this wrapper... */}
                        {renderCartItems(this.props.cart.items, true)}
                    </div>

                    {this.renderPromo()}

                    {(this.props.cart.loyalty_rewards.length > 0) && this.renderLoyaltyRewards()}

                    {this.renderTotals()}

                    {(this.props.cart.order_type == "delivery") && this.renderTipWindow()}
                
                    {this.renderOrderInformation()}


                    {this.renderCheckoutPaymentInfo()}


                    {/* FIXED BOTTOM BUTTON */}
                    <div className="checkout-bottom-button-wrapper">
                        <a
                            className="checkout-bottom-button"
                            onClick={this.validateCard}
                        >
                            Let's Eat!
                        </a>
                    </div>

                    <div className="cart-information-continue">
                        {/* Is this div still necessary? */}
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {

    return {
        token: state.auth.token,
        logged_in: state.auth.logged_in,
        loggedUser: state.auth.user,
        cart: state.cart,
        viewCCInfo: state.cart.viewCCInfo,
        currentLocation: state.currentLocation.info,
        device: state.device
    };
  };

export default connect(mapStateToProps)(OrderCheckout);
